// Static URL
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const localUrl = process.env.REACT_APP_LOCAL_URL;

// Grochat URL
export const grochatUrl = process.env.REACT_APP_GROCHAT_URL;
export const grochatPwaUrl = process.env.REACT_APP_GROCHAT_PWA_URL;
export const grochatWebsocketUrl = process.env.REACT_APP_GROCHAT_WS_URL;

// Version
export const nexcareVersion = process.env.REACT_APP_NEXCARE_VERSION;

// Chatbot
export const chatBotCreateTicketUrl = process.env.REACT_APP_CHATBOT_CREATE_TICKET_URL;